import axiosInstance from "./axiosSetup";
import {
  CheckOverwriteRequest,
  CheckOverwriteResponse,
  DocumentTypesResponse,
  FormDefinitionResponse,
  IngestionStatusResponse,
  ResolveRequest,
  ResolveResponse,
  UploadResponse,
} from "../types/configurableUpload";

export const getConfigurableDocumentTypes = async () => {
  const response = await axiosInstance.get<DocumentTypesResponse>(
    "/uploader/config/document-types",
  );
  return response.data;
};

export const getConfigurableFormDefinition = async (documentTypeKey: string) => {
  const response = await axiosInstance.get<FormDefinitionResponse>(
    `/uploader/config/forms/${encodeURIComponent(documentTypeKey)}`,
  );
  return response.data;
};

export const resolveConfigurableForm = async (request: ResolveRequest) => {
  const response = await axiosInstance.post<ResolveResponse>(
    "/uploader/config/resolve",
    request,
  );
  return response.data;
};

export const checkConfigurableOverwrite = async (
  request: CheckOverwriteRequest,
) => {
  const response = await axiosInstance.post<CheckOverwriteResponse>(
    "/uploader/config/check-overwrite",
    request,
  );
  return response.data;
};

export const uploadConfigurableDocument = async (
  documentTypeKey: string,
  formValues: Record<string, string | string[] | null>,
  file: File,
) => {
  const data = new FormData();
  data.set("documentTypeKey", documentTypeKey);
  data.set("formValues", JSON.stringify(formValues));
  data.set("file", file);

  const response = await axiosInstance.post<UploadResponse>(
    "/uploader/config/upload",
    data,
  );
  return response.data;
};

export const getConfigurableIngestionStatus = async (uploadId: string) => {
  const response = await axiosInstance.get<IngestionStatusResponse>(
    "/uploader/config/ingestion-status",
    { params: { uploadId } },
  );
  return response.data;
};
